import { updateIsRefresh } from "@/redux/actions/lightningAction";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

interface UseInactivityWarningOptions {
  isClickedSearchResultButton: boolean;
  timeoutMs: number;
}

const useInactivityWarning = ({ isClickedSearchResultButton, timeoutMs }: UseInactivityWarningOptions) => {
    const dispatch = useDispatch();
    const lastActivityRef = useRef<number>(Date.now());
    const inactivityTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const isActiveRef = useRef<boolean>(false); // 标记是否处于监听状态

    console.log("lanxue isClickedSearchResultButton ",isClickedSearchResultButton);
    const showWarning = () => {
        console.log(`lanxue isClickedSearchResultButton 用户已点击搜索按钮，但 ${timeoutMs / 1000} 秒内无任何鼠标操作！`);
        dispatch(updateIsRefresh(true));
        // ⚠️ 触发后继续监听下一个周期
        startInactivityTimer();
    };

    const startInactivityTimer = () => {
        if (inactivityTimeoutRef.current) {
            clearTimeout(inactivityTimeoutRef.current);
        }

        inactivityTimeoutRef.current = setTimeout(() => {
            const now = Date.now();
            const inactivityDuration = now - lastActivityRef.current;

            if (inactivityDuration >= timeoutMs) {
                showWarning();
            } else {
                // 如果用户在这段时间内有操作，重新计算剩余时间
                const remainingTime = timeoutMs - inactivityDuration;
                inactivityTimeoutRef.current = setTimeout(showWarning, remainingTime);
            }
        }, timeoutMs);
    };

    const handleActivity = () => {
        lastActivityRef.current = Date.now();
        if (isActiveRef.current) {
            startInactivityTimer(); // 有活动就重启定时器
        }
    };

    useEffect(() => {
        const events = ["mousemove", "mousedown"];
        events.forEach((event) => {
            window.addEventListener(event, handleActivity);
        });

        // 当点击搜索按钮时，启动监听
        if (isClickedSearchResultButton) {
            isActiveRef.current = true;
            lastActivityRef.current = Date.now();
            startInactivityTimer();
        }

        return () => {
            events.forEach((event) => {
                window.removeEventListener(event, handleActivity);
            });
            if (inactivityTimeoutRef.current) {
                clearTimeout(inactivityTimeoutRef.current);
            }
        };
    }, [isClickedSearchResultButton, timeoutMs]);

    // 👇 可选：如果你想在组件卸载或 isClickedSearchResultButton 变为 false 时停止监听
    useEffect(() => {
        if (!isClickedSearchResultButton) {
            isActiveRef.current = false;
            if (inactivityTimeoutRef.current) {
                clearTimeout(inactivityTimeoutRef.current);
            }
        }
    }, [isClickedSearchResultButton]);
};

export default useInactivityWarning;